import { ApplicationConfig } from '@angular/core';
import { MenuService as BaseMenuService } from 'app';
import { createAppConfig } from 'credo';
import { routes } from './app.routes';
import { Logo } from 'shared';
import { environment } from './environments/environment';
import { MenuService } from './services/menu.service';


// export const appRoutes = createShellRoutes()
//   .withMainComponent(MainComponent)

//   // Replace any route
//   .replace('login', { path: 'signin', component: CustomLoginComponent })
//   .replace('tos', { path: 'terms', component: MyTermsComponent })
//   .replace('media', { path: 'content', children: [/* custom content area */] })

//   // Add new routes
//   .addProtected(
//     { path: 'admin', component: AdminComponent },
//     { path: 'reports', loadChildren: () => import('./reports') }
//   )
//   .addAuthenticated({ path: 'notifications', component: NotificationsComponent })

//   .build();

export const appConfig: ApplicationConfig = createAppConfig({
  providers: [
    { provide: BaseMenuService, useClass: MenuService },
  ],
  routes: [
    ...routes
  ],
  translationScope: 'nam3less',
  environment,
  // logo: {
  //   type: 'image',
  //   value: ['./assets/icons/logo.png'],
  //   name: 'logo',
  //   cssClass: 'logo'
  // } as Logo
});